import { TreeItem as FluentTreeItem } from "@fluentui/web-components";
/**
 * TreeItem
 * @summary A Fabric UI TreeItem component that extends Fluent UI's TreeItem with custom styling and behavior.
 *
 * @example
 * ```html
 * <fabric-tree-item expanded selected>
 *   <span slot="start">📁</span>
 *   Folder Name
 *   <span slot="end">🔔</span>
 *   <fabric-tree-item>Child Item</fabric-tree-item>
 * </fabric-tree-item>
 * ```
 *
 * @attr {boolean | undefined} expanded - Whether the tree item is expanded to show child items.
 * @attr {boolean | undefined} selected - Whether the tree item is selected.
 * @attr {boolean | undefined} empty - Whether the tree item has no child items.
 * @attr {string | undefined} size - The size of the tree item (small, medium).
 * @attr {string | undefined} appearance - The appearance variant (subtle, subtleAlpha, transparent).
 * @attr {number | undefined} data-indent - The indentation level for nested items.
 *
 * @prop {boolean} expanded - Whether the tree item is expanded.
 * @prop {boolean} selected - Whether the tree item is selected.
 * @prop {boolean} empty - Whether the tree item has no child items.
 * @prop {string} size - The size of the tree item.
 * @prop {string} appearance - The appearance variant.
 * @prop {number} dataIndent - The indentation level.
 * @prop {Array} childTreeItems - Array of child tree items.
 * @prop {boolean} isNestedItem - Whether this item is nested within another tree item.
 *
 * @slot default - The main content of the tree item.
 * @slot start - Content displayed before the main content (typically icons).
 * @slot end - Content displayed after the main content.
 * @slot aside - Content displayed at the far end of the tree item.
 * @slot chevron - Custom expand/collapse indicator (defaults to built-in chevron).
 * @slot item - Container where child tree items are automatically placed.
 *
 * @csspart positioning-region - Container for the tree item content and aside sections.
 * @csspart content - Container for the main tree item content (chevron, start, default, end slots).
 * @csspart chevron - The expand/collapse indicator.
 * @csspart aside - Container for the aside slot content.
 * @csspart items - Container for nested child tree items.
 *
 * @method toggleExpansion - Toggles the expanded state if the item has children.
 * @method updateChildTreeItems - Updates the indentation and appearance of child items.
 * @method updateSizeAndAppearance - Updates size and appearance of all child tree items.
 *
 * @fires toggle - Fired when the expanded state changes. Detail: {oldState: string, newState: string}
 * @fires change - Fired when the selected state changes.
 *
 * @extends FluentTreeItem
 * @tagname fabric-tree-item
 * @public
 */
export class TreeItem extends FluentTreeItem {
}
//# sourceMappingURL=tree-item.js.map